import { z } from "zod";
const recordingIntakeIdSchema = z.uuid().brand();
function asRecordingIntakeId(id) {
  return recordingIntakeIdSchema.parse(id);
}
const recordingIntakeErrorSchema = z.object({
  code: z.string(),
  message: z.string()
});
const allRecordingIntakeStatuses = [
  "pending",
  "imported",
  "failed",
  "skipped"
];
const recordingIntakeStatusSchema = z.enum(allRecordingIntakeStatuses);
const RECORDING_INTAKE_UNKNOWN_BUCKET_CODE = "unknown_bucket";
const RECORDING_INTAKE_FILE_NOT_FOUND_CODE = "file_not_found";
const RECORDING_NO_ROUTING_RULE_MATCHED_MESSAGE = "No routing rule matched for the teammate";
const RECORDING_INTAKE_UNKNOWN_COMPANY_KEY = "none";
const RECORDING_INTAKE_NO_ERROR_CODE_KEY = "__none__";
const RECORDING_INTAKE_TRIAGE_PAGE_SIZE = 50;
const recordingIntakeTriageStatuses = ["failed", "skipped"];
const recordingIntakeRequeueOutcomes = [
  "requeued",
  "unknown_bucket",
  "noop"
];
const RECORDING_INTAKE_BULK_ACTION_MAX_IDS = 1e3;
const RECORDING_INTAKE_CUSTOMER_BULK_ACTION_MAX_IDS = 200;
const recordingIntakeFailedImportErrorLabels = {
  skill_not_mapped: "Skill not mapped",
  campaign_not_mapped: "Campaign not mapped",
  playbook_not_found: "Playbook not found",
  teammate_not_found: "Agent not matched",
  unresolved_agent: "Agent not matched",
  no_contact_number: "No contact number",
  anonymous_contact_number: "Caller withheld number",
  unusable_contact_number: "Unusable contact number",
  recording_too_large: "Recording too large",
  attempts_exhausted: "Import failed",
  unknown_bucket: "Unrecognized bucket",
  // `file_not_found` lands on `skipped` rows. No surface renders it through this
  // map today — the customer failed-imports tab is failed-only and HQ shows raw
  // codes — but the entry keeps a friendly label ready for a skipped-row view and
  // stays consistent with the other codes.
  file_not_found: "Recording no longer available",
  no_routing_for_teammate: "No routing for teammate"
};
function getRecordingIntakeFailedImportErrorLabel(code) {
  if (!code) {
    return null;
  }
  return recordingIntakeFailedImportErrorLabels[code] ?? code;
}
export {
  RECORDING_INTAKE_BULK_ACTION_MAX_IDS,
  RECORDING_INTAKE_CUSTOMER_BULK_ACTION_MAX_IDS,
  RECORDING_INTAKE_FILE_NOT_FOUND_CODE,
  RECORDING_INTAKE_NO_ERROR_CODE_KEY,
  RECORDING_INTAKE_TRIAGE_PAGE_SIZE,
  RECORDING_INTAKE_UNKNOWN_BUCKET_CODE,
  RECORDING_INTAKE_UNKNOWN_COMPANY_KEY,
  RECORDING_NO_ROUTING_RULE_MATCHED_MESSAGE,
  asRecordingIntakeId,
  getRecordingIntakeFailedImportErrorLabel,
  recordingIntakeErrorSchema,
  recordingIntakeFailedImportErrorLabels,
  recordingIntakeIdSchema,
  recordingIntakeRequeueOutcomes,
  recordingIntakeTriageStatuses
};
//# sourceMappingURL=recordingIntake.js.map
